import * as React from "react";
import { Dialog } from "../../framework/Dialog/Dialog";
import { Translations } from "ui/Scripts/source/models/translations";
import { UserRemoveType } from "ui/Scripts/source/models/enums";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { FormControlLabel, Grid, Radio } from "@mui/material";

export interface IUserEditRemoveSelectTypeDialogProps {
    onOk: (removeType: UserRemoveType) => void;
    onCancel: () => void;
}

export interface IUserEditRemoveSelectTypeDialogState {
    removeType: UserRemoveType;
}

export class UserEditRemoveSelectTypeDialog extends React.Component<IUserEditRemoveSelectTypeDialogProps, IUserEditRemoveSelectTypeDialogState> {
    constructor(props: IUserEditRemoveSelectTypeDialogProps) {
        super(props);
        this.state = {
            removeType: UserRemoveType.RemoveUser
        };
    }

    handleChange = (checked: boolean, removeType: UserRemoveType) => {
        if (!checked) return;
        this.setState({
            removeType
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleOk = async () => {
        const state = this.state;
        this.props.onOk(state.removeType);
    };

    render() {
        const state = this.state;
        return (
            <Dialog
                id="userEditRemoveSelectTypeDialog"
                title={Translations.SelectRemovingMethod}
                body={
                    <>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.RemoveUserAndKeepRecordUser}
                                    control={
                                        <Radio
                                            checked={state.removeType === UserRemoveType.RemoveUser}
                                            onChange={(_e, checked: boolean) => {
                                                this.handleChange(checked, UserRemoveType.RemoveUser);
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.RemoveUserAndRecordUserArchive}
                                    control={
                                        <Radio
                                            checked={state.removeType === UserRemoveType.RemoveUserAndRecordUserArchive}
                                            onChange={(_e, checked: boolean) => {
                                                this.handleChange(checked, UserRemoveType.RemoveUserAndRecordUserArchive);
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.RemoveUserAndRecordUser}
                                    control={
                                        <Radio
                                            checked={state.removeType === UserRemoveType.RemoveUserAndRecordUser}
                                            onChange={(_e, checked: boolean) => {
                                                this.handleChange(checked, UserRemoveType.RemoveUserAndRecordUser);
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                    </>
                }
                buttons={[
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk },
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}